// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"610":"c63dbcb7","617":"bf756327","896":"5f0a88d9","928":"97ea26d1","985":"ae66933b"}[chunkId] + ".chunk.css";
};